export const detectGroupMembership = (
  title: string,
  description = ""
): {
  audience: "family" | "group";
  field: "name" | "description";
} | null => {
  const fields = [
    { field: "name", value: title },
    { field: "description", value: description },
  ] as const;
  for (const { field, value } of fields) {
    if (/\b(famil(y|ies)|household|couples?|spouse|dual|duo|joint|two adults|2 adults)\b/i.test(value)) {
      return { audience: "family", field };
    }
    if (/\b(groups?|teams?)\b/i.test(value)) {
      return { audience: "group", field };
    }
  }
  return null;
};
